import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  accordion: {
    width: '100%',
    overflow: 'hidden',
    border: 0,
    backgroundColor: theme.white,

    '&.isGrey': {
      backgroundColor: theme.colors.gray2[0],
    },
    '&.isDark': {
      backgroundColor: theme.colors.gray2[4],
    },

    '&:first-child': {
      borderTopLeftRadius: theme.other.spacing._16,
      borderTopRightRadius: theme.other.spacing._16,
    },

    '&:last-child': {
      borderBottomLeftRadius: theme.other.spacing._16,
      borderBottomRightRadius: theme.other.spacing._16,
    },

    '&:last-child hr': {
      display: 'none',
    },
  },
  item: {
    width: '100%',
    border: 0,
    position: 'relative',
  },
  title: {
    whiteSpace: 'nowrap',
  },
  control: {
    width: '100%',
    display: 'flex',
    padding: theme.other.spacing._16,
    transition: 'background-color 0.2s ease-in-out',
    color: theme.colors.gray[7],

    ':hover': {
      opacity: 0.5,
    },

    '.isGrey &': {
      color: theme.colors.gray2[6],
    },
    '.isDark &': {
      color: theme.white,
    },
    '.isDark &:hover': {
      opacity: 1,
      backgroundColor: theme.colors.gray2[3],
    },
  },
  panel: {
    border: 0,
    color: theme.colors.gray[4],

    '.mantine-Accordion-content': {
      padding: `0 ${theme.other.spacing._16}px`,
    },

    '.isGrey &': {
      color: theme.colors.gray2[6],
    },
    '.isDark &': {
      color: theme.white,
    },
  },
  divider: {
    border: 'none',
    borderTop: `1px solid ${theme.colors.gray[1]}`,
    margin: `0 ${theme.other.spacing._16}px`,
    background: 'none',
    padding: 0,

    '.isGrey &': {
      borderTopColor: theme.colors.gray2[1],
    },
    '.isDark &': {
      borderTopColor: theme.colors.dark[4],
    },
  },
}));

export default useStyles;
